// extracted by mini-css-extract-plugin
module.exports = {"basic":"_7a3fb80146--basic--_36CO","controls":"_7a3fb80146--controls--gvgwf"};